import { useEffect, useMemo, useState } from 'react';
import arrow from '../../../assets/images/svgIcons/accordian_arrow.svg';
import InputSearch from '../../../components/InputSearch';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { getdivisionThunk } from '../../../store/asyncThunks/scope/scope';
import { Card } from 'reactstrap';
import TableWithCardLoader from '../../../components/TableWithCardLoader';
interface divisionScopeProps {
    print?: any
    expandTableRow?: Boolean
}

const DivisionScope = (props: divisionScopeProps) => {
    const { print, expandTableRow } = props
    const dispatch = useAppDispatch();

    const pageSize = process.env.REACT_APP_PAGE_SIZE || 10;
    const divisionState = useAppSelector((state) => state.getdivisionReducer?.data?.data);
    const divisionStateLoading = useAppSelector((state) => state.getdivisionReducer?.loading);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState("");
    const handleSearch = (value: any) => {
        setCurrentPage(1)
        setSearchValue(value);
    }

    useEffect(() => {
        const data: any = {}
        data["data"] = { search: searchValue, status: "ACTIVE" }
        data["currentPage"] = currentPage
        data["pageSize"] = pageSize
        dispatch(getdivisionThunk(data));
    }, [searchValue, currentPage]);

    const columns = useMemo(
        () => [
            {
                Header: 'List of division',
                accessor: '',
                Cell: (cell: any) => {
                    return <div className='label-cell'>{cell?.row?.original?.label}</div>;
                },
            },
            {
                accessor: 'search',
                Cell: (cell: any) => {
                    return <div className='actions'>
                        <div className={`arrow d-flex justify-content-end`}>
                            <img src={arrow} alt="arrow" />
                        </div>
                    </div>
                },
            },
        ], [divisionState]);

    const subTable = (row: any) => {
        const { scope } = row.original
        return (
            <>
                <div className="d-scope">
                    <p className="description">{scope}</p>
                </div>
            </>
        )
    }

    return (
        <>
            <div ref={print} className='division-scope'>
                <div className='table-search'>
                    <InputSearch onSearch={handleSearch} value={searchValue} />
                </div>
                <Card className={!divisionState || divisionState?.divisions == 0 ? `loader-card` : ""} >
                    <TableWithCardLoader
                        data={divisionState?.divisions || []}
                        columns={columns}
                        totalCount={divisionState?.totalCount}
                        customPageSize={Number(pageSize)}
                        dynamicPagination={true}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        renderRowSubComponent={subTable}
                        isExpanded={true}
                        expandAll={expandTableRow}
                        loader={divisionStateLoading}
                    />
                </Card>
            </div>
        </>
    )
}
export default DivisionScope